export enum MonthEndActionType {
  Proceed = 1,
  Retry = 2,
  Complete = 3,
}
